module.exports = __webpack_public_path__ + "img/icon_fd_u30.d45c80bc.png";